import { enableSocket } from '../../constants'
import { sendData } from '../../data/sendData'
import { socket } from '../../socket'
import { _hub_exp_thisTask } from '../hub'
import { Button } from '@material-ui/core'
import { green } from '@material-ui/core/colors'
import { ThemeProvider, createTheme } from '@material-ui/core/styles'
import { SkipNextRounded } from '@material-ui/icons'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

const theme = createTheme({
  palette: {
    secondary: {
      main: green[500],
      darker: green[800],
      contrastText: green[50],
    },
  },
})

export default class NextButton extends Component {
  constructor(props) {
    super(props)

    this.next = this._next.bind(this)
  }

  _next(e) {
    if (enableSocket) socket.emit('nextTrial')
    sendData('buttonnexttrial', e, {
      touchSpeed: 0,
      touchTarget: 'nextButton',
      selectionArray: this.props.selectedArray,
      textArray: _hub_exp_thisTask.text,
    })
  }

  render() {
    return (
      <ThemeProvider theme={theme}>
        <Button
          key="next-button"
          className={'next-button'}
          variant="contained"
          color="secondary"
          size="large"
          disableElevation
          onClick={this.next}
          sx={{
            position: 'fixed',
            bottom: '3rem',
            left: '1rem',
            height: '3rem',
            borderRadius: '7px',
          }}
        >
          <SkipNextRounded
            sx={{
              fill: green[50],
            }}
          />
        </Button>
      </ThemeProvider>
    )
  }
}

NextButton.propTypes = {
  selectedArray: PropTypes.array,
}
